import Tippy from '@tippyjs/react';

import { TYPE_LABELS } from 'lib/constants/transaction/typeLabels';
import numOrDefault from 'lib/helpers/numOrDefault';
import { formatDateAndTime, mString, snakeToTitleCase } from 'lib/helpers/utility';

import Actions from 'components/admin/pages/AdminIQueue/Transactions/components/Actions';
import CardProcessor from 'components/shared/CardProcessor';
import Icon from 'components/shared/Icon/Icon';
import AmountPaidSelf from 'components/shared/Transactions/components/AmountPaidSelf';

export const COLUMNS = [
  { field: 'id', headerName: 'ID', maxWidth: 100 },
  { field: 'practice_id', headerName: 'Practice ID' },
  { field: 'practice.name', headerName: 'Practice Name', sortable: false },
  {
    field: 'patient_id',
    headerName: 'Patient ID',
    width: 300,
    valueFormatter: ({ value }) => (value ? value : '-')
  },
  {
    field: 'patient.fullName',
    headerName: 'Patient Name',
    width: 300,
    valueFormatter: ({ value }) => (value ? value : '-'),
    sortable: false
  },
  {
    field: 'created_at',
    headerName: 'Date',
    valueFormatter: ({ value }) => (value ? formatDateAndTime(value) : '-')
  },
  {
    field: 'status',
    headerName: 'Status',
    valueFormatter: ({ value }) => (value ? snakeToTitleCase(value) : '-'),
    cellRenderer: ({ value, data }) => {
      return (
        <div className="flex items-center gap-2">
          <p className="w-fit">{value ? snakeToTitleCase(value) : '-'}</p>
          {data?.status_description && (
            <Tippy
              className="tippy-dark"
              content={
                <span className="block max-w-[24rem] break-words">
                  {String(data?.status_description || '')}
                </span>
              }
              allowHTML={false}>
              <div aria-label="Status info">
                <Icon icon="info-mono" className="cursor-help" />
              </div>
            </Tippy>
          )}
        </div>
      );
    }
  },
  {
    field: 'amount_paid_self',
    headerName: 'Amount',
    initialWidth: 260,
    valueFormatter: ({ value, data }) => {
      let result = mString(numOrDefault(value) + (data?.amount_refunded ?? 0));
      if (data?.amount_refunded) {
        result += `(Refunded: -${mString(data.amount_refunded)})`;
      }
      return result;
    },
    cellRenderer: ({ value, data }) => {
      return <AmountPaidSelf value={value} data={data} />;
    },
    aggFunc: 'sum'
  },
  {
    field: 'type',
    headerName: 'Type',
    valueFormatter: ({ value }) => (value ? TYPE_LABELS[value] : '-')
  },
  {
    field: 'cc_type',
    headerName: 'Card Type',
    cellRenderer: ({ value }) => {
      return (
        <div className="flex h-full items-center justify-center">
          {value ? <CardProcessor>{value}</CardProcessor> : '-'}
        </div>
      );
    }
  },
  {
    field: 'cc_number_last_four',
    headerName: 'Card Number (Last 4)',
    valueFormatter: ({ value }) => (value ? value : '-'),
    sortable: false
  },
  {
    field: 'cashier.fullName',
    headerName: 'Cashier',
    valueFormatter: ({ value }) => (value ? value : '-'),
    sortable: false
  },
  {
    field: 'actions',
    headerName: 'Actions',
    cellRenderer: (params) => (
      <Actions
        data={{
          ...params.data,
          isPatient: true
        }}
      />
    ),
    maxWidth: 88,
    minWidth: 36,
    resizable: false,
    sortable: false,
    pinned: 'right',
    no_show_csv: true
  }
];
